import {setScreen} from '../../services/router';

export default function NotFoundPage() {
  return <div>Screen is not found</div>;
}
